import config from "config";

const gotToPricing = () => {
	location.href = config.urls.pricing;
	return;
};

export { gotToPricing };
